@if (loading) {
  <div class="flex items-center justify-center py-10">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
} @else {
  <!-- Header -->
  <div class="mb-6 font-lato">
    <!-- Back nav -->
    <button
      type="button"
      class="inline-flex items-center gap-1 font-lato text-sm font-medium text-blue-600 hover:underline focus:outline-none"
      (click)="goBack()"
    >
      <mat-icon class="!flex !h-4 !w-4 !items-center !justify-center !text-base" aria-hidden="true">arrow_back</mat-icon>
      Orders
    </button>

    <!-- Title row -->
    <div class="mt-2 flex items-center justify-between gap-4">
      <h1 class="font-montserrat text-2xl font-bold text-blue-950">
        {{ order.nit }}
      </h1>
      <button class="btn-primary shrink-0" (click)="onCreateTicket()">
        Create Ticket
      </button>
    </div>
  </div>
}

<!-- Order Data -->
<div class="gap-4 font-lato font-normal md:flex md:items-start md:justify-between">
  <!-- Column 1 -->
  <div class="flex flex-1 flex-col gap-4">
    <app-order-details-box
      class="w-full"
      title="General Information"
      [data]="generalInfo"
    />

    @if (!datesInCenter) {
      <app-order-dates-box class="w-full" [dates]="keyDates" />
    }
  </div>

  <!-- Column 2 -->
  <div class="flex flex-1 flex-col gap-4">
    @if (basicServiceInfo?.length > 0) {
      <app-order-details-box
        class="w-full"
        title="Basic Service Information"
        [data]="basicServiceInfo"
      />
    }

    @if (datesInCenter) {
      <app-order-details-box
        class="w-full"
        title="Circuit Order Specifics"
        [data]="circuitOrdersInfo"
      />
    } @else {
      <app-order-dates-box class="w-full" [dates]="keyDates" />
    }
  </div>

  <!-- Column 3 -->
  <div class="flex flex-1 flex-col gap-4">
    <app-order-contacts-box class="w-full" [data]="contactsInfo" />
  </div>
</div>
